export default __webpack_public_path__ + "static/media/nesto-online-grocery-delivery.5b53a255.svg";